import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

// Height of the bar at the top of the map. Overlays that must not cover it
// (see ControlPanel) lay themselves out below this offset.
export const PROGRESS_BAR_HEIGHT = 6;

export default function RealTimeProgress(props) {


    return (
    <Box sx={{ width: '100%', pt:0.2, height: PROGRESS_BAR_HEIGHT, zIndex:99, position: 'absolute',top:"0vh"}}>
      <LinearProgress variant="determinate" value={props.progress*props.scaler} />
    </Box>
  );
}